import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="hoa-card p-10 max-w-lg w-full text-center">
        <XCircle className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
        <h1 className="text-2xl font-semibold mb-2">Checkout cancelled</h1>
        <p className="text-sm text-muted-foreground mb-6">
          No charge was made. You can pick a plan any time.
        </p>
        <Link to="/subscription">
          <Button className="rounded-full bg-gold text-secondary-foreground hover:brightness-110" data-testid="back-to-subscription-btn">
            Back to subscription
          </Button>
        </Link>
      </div>
    </div>
  );
}
